"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _modal = _interopRequireDefault(require("../../../core/modal"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _styledComponents = require("styled-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  requestDetail: false,
  requesting: false
};
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Please wait whilst emails are sent");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "This will move calendar applications into \"Yearbook Detail Requested\" status and send emails to the application creators requesting that they complete the detailed data.");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, "Note that applications will be ignored if they:");
var _ref4 = /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "have previously been rejected/deleted"), /*#__PURE__*/_react.default.createElement("li", null, "are already in Request status (ie: creator will not get a repeat email)"), /*#__PURE__*/_react.default.createElement("li", null, "have been submitted and or finally accepted"));
class RequestYearbookDetails extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleRequest", () => {
      this.setState({
        requestDetail: !this.state.requestDetail
      });
    });
    _defineProperty(this, "_onConfirm", () => {
      if (this.state.requesting) return;
      this.setState({
        requesting: true
      });
      return this.props.onRequestYearbookDetails(this.props.calendar.id).then(() => this.setState(initialState));
    });
  }
  render() {
    const today = new Date().toISOString().split('T')[0];
    const calendar = this.props.calendar;
    return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      disabled: this.state.requesting || !calendar.approvalDate || calendar.approvalDate > today,
      onClick: this._onToggleRequest
    }, "Request Yearbook Details"), !this.state.requestDetail ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: 'Request Yearbook Details',
      onClose: this._onToggleRequest,
      buttons: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        disabled: this.state.requesting,
        onClick: this._onToggleRequest
      }, "Cancel"), ' ', /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onConfirm
      }, "Confirm Request")),
      size: "lg"
    }, this.state.requesting ? _ref : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref2, _ref3, _ref4)));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(RequestYearbookDetails, "partialQueries", {
  Calendar: {
    id: true,
    approvalDate: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(RequestYearbookDetails, undefined, (client, props) => ({
  onRequestYearbookDetails(calendarID) {
    return client.update('Calendar.requestYearbookDetails', {
      calendarID
    });
  }
}));